import { styles } from '../styles';
import { hero, socials } from '../constants/constants'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';

const Hero = () => {
    return (
        <section id="hero" className="w-full h-[70vh]">
            <div className="flex w-full absolute top-[200px] mx-auto max-w-7xl my-10">
                <div className='xl:bg-black bg-none flex w-full justify-center flex-row gap-10 p-10 lg:rounded-r-3xl'>
                    <div className='flex flex-col items-center mt-5'>
                        <div className='w-1 sm:h-80 h-40 bg-secondary' />
                    </div>
                    <div className='text-left'>
                        <h1 className={`${styles.heroHeadText}`}>{hero.text}</h1>
                        <p className={`${styles.heroSubText}`}>{hero.subtext}</p>
                        <br />
                        <br />
                        <a href={socials.github.link} target='_blank' rel="noreferrer" className='flex flex-row items-center gap-2'>
                            <FontAwesomeIcon icon={faGithub} className='text-3xl' />
                            <p>Github</p>
                        </a>
                        <a href={socials.linkedin.link} target='_blank' rel="noreferrer" className='flex flex-row items-center gap-2 mt-2'>
                            <FontAwesomeIcon icon={faLinkedin} className='text-3xl' />
                            <p>Linkedin</p>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Hero;